import { Profile, Links } from '@/lib/types'
import { Button } from '@/ui'
import { useTranslation } from '@/i18n'

interface RecruiterHeroProps {
  profile: Profile
  links: Links
}

export function RecruiterHero({ profile, links }: RecruiterHeroProps) {
  const { t } = useTranslation()

  return (
    <section className="py-16 px-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Avatar */}
        <div className="mb-6">
          {profile.avatar ? (
            <img
              src={profile.avatar}
              alt={profile.full_name}
              className="w-32 h-32 mx-auto rounded-full object-cover border-4 border-gray-200 dark:border-gray-700"
            />
          ) : (
            <div className="w-32 h-32 mx-auto rounded-full bg-gray-200 flex items-center justify-center text-4xl font-bold text-gray-400 dark:bg-gray-700 dark:text-gray-500">
              {profile.full_name.charAt(0)}
            </div>
          )}
        </div>

        <h1 className="text-5xl font-bold mb-4 dark:text-gray-100">{profile.full_name}</h1>
        <p className="text-2xl text-gray-600 mb-6 dark:text-gray-400">{profile.headline}</p>
        <p className="text-lg text-gray-700 max-w-2xl mx-auto mb-8 dark:text-gray-300">
          {profile.summary_short}
        </p>

        <div className="flex gap-4 justify-center">
          <Button variant="primary" size="lg" href={`mailto:${links.email}`}>
            {t('hero.contactMe')}
          </Button>
        </div>
      </div>
    </section>
  )
}
